/**
 * Единственный источник правды для дизайн-токенов.
 * Все цвета/отступы/тени берутся отсюда через ThemeProvider — магических
 * значений в компонентах быть не должно.
 */
export const theme = {
  colors: {
    primary: "#00a6d6",
    primaryDark: "#008bb5",
    primarySoft: "#f0faff",
    onPrimary: "#ffffff",

    heading: "#111827",
    text: "#333333",
    textMuted: "#667085",

    surface: "#ffffff",
    surfaceAlt: "#f6f6f6",
    border: "#e4e7ec",

    focus: "#005f7a",
  },

  radii: {
    sm: "6px",
    md: "10px",
    lg: "16px",
    xl: "25px",
    pill: "999px",
  },

  shadows: {
    card: "0 4px 8px rgba(0, 0, 0, 0.08)",
    cardHover: "0 8px 20px rgba(0, 166, 214, 0.18)",
    menu: "0 8px 24px rgba(0, 0, 0, 0.16)",
  },

  fontSizes: {
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "18px",
    xl: "20px",
    h3: "24px",
    h2: "28px",
    h1: "32px",
    display: "40px",
  },

  layout: {
    maxWidth: "1280px",
    gutter: "20px",
    headerHeight: "72px",
  },

  transitions: {
    base: "0.25s ease",
  },

  zIndex: {
    dropdown: 20,
    header: 30,
    overlay: 40,
    drawer: 50,
  },
};

export default theme;
